import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tinct/web-components';
import { ServiceAccount } from '@tinct/core-api-models';
import { useDisableServiceAccount } from '@tinct/core-api';
import { IconBan } from '@tabler/icons-react';
import { toast } from 'sonner';

type DisableServiceAccountModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  organizationId: string;
  serviceAccount: ServiceAccount;
};

export const DisableServiceAccountModal = ({
  open,
  onOpenChange,
  organizationId,
  serviceAccount,
}: DisableServiceAccountModalProps) => {
  const disableServiceAccount = useDisableServiceAccount({
    onSuccess: () => {
      toast.success('Service account disabled');
      onOpenChange(false);
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to disable service account');
    },
  });

  const handleDisable = () => {
    if (!serviceAccount.id) return;
    disableServiceAccount.mutate({
      organizationId,
      serviceAccountId: serviceAccount.id,
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Disable service account</DialogTitle>
        </DialogHeader>

        <div className="flex gap-3 items-start rounded-lg border border-rose-200 bg-rose-50 px-4 py-3">
          <div className="pt-0.5">
            <IconBan className="size-4 text-destructive" />
          </div>
          <div className="flex flex-col gap-1 flex-1 text-destructive">
            <p className="text-sm font-medium">
              Service account: {serviceAccount.name}
            </p>
            <p className="text-sm">
              Its tokens stop being accepted within seconds and no new token can
              be obtained. It can be re-enabled at any time.
            </p>
          </div>
        </div>

        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={handleDisable}
            isLoading={disableServiceAccount.isPending}
          >
            Disable
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
